import request from '@/utils/request'

export function pageLiveCourseSectionReplay(data) {
  return request({
    url: '/livecourse/liveCourseSectionReplay/page',
    method: 'post',
    data: data
  })
}

export function addLiveCourseSectionReplay(data) {
  return request({
    url: '/livecourse/liveCourseSectionReplay/add',
    method: 'post',
    data: data
  })
}

export function updateLiveCourseSectionReplay(data) {
  return request({
    url: '/livecourse/liveCourseSectionReplay/edit',
    method: 'post',
    data: data
  })
}

export function delLiveCourseSectionReplay(data) {
  return request({
    url: '/livecourse/liveCourseSectionReplay/delete',
    method: 'post',
    data: data
  })
}
